<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />

  <div v-else class="animated fadeIn mb-4">
    <default-heading class="mt-3">
      {{ project.pid }}
    </default-heading>

    <div class="mt-3" />

    <b-row>
      <b-col>
        <b-card>
          <div>
            <b-table-lite
              :items="projectInfoRows"
              striped
              small
              bordered
              thead-class="d-none"
            />
          </div>
        </b-card>
      </b-col>

      <b-col>
        <b-card>
          <h4>Project Status</h4>

          <b-table-lite
            :items="projectStatusInfoRows"
            striped
            small
            bordered
            thead-class="d-none"
          />
        </b-card>
      </b-col>
    </b-row>

    <ProjectDetailCardstack :project="project" />
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import LoadingOverlay from '@/components/shared/LoadingOverlay'
import ProjectModel from '@/models/lab/ProjectModel'
import ProjectDetailCardstack from '@/components/lab/projects/ProjectDetailCardstack'
import moment from 'moment'

export default {
  name: 'ProjectDetail',
  components: {
    DefaultHeading,
    LoadingOverlay,
    ProjectDetailCardstack
  },
  data () {
    return {
      loading: true,
      project_id: this.$route.params.project_id,
      project: null
    }
  },
  computed: {
    projectInfoRows () {
      const rows = []

      if (this.project) {
        rows.push(
          {
            label: 'Created On',
            value: moment(this.project.created_at).format('L')
          },
          {
            label: 'Submissions',
            value: this.project.getSubmissions()
              ? this.project.getSubmissions().models.length
              : 0
          }
        )
      }

      return rows
    },
    projectStatusInfoRows () {
      const rows = []

      if (this.project) {
        rows.push(
          {
            label: 'Status',
            value: this.project.getProjectStatusLogs()
              ? this.project
                  .getProjectStatusLogs()
                  .first()
                  .getProjectStatus().status
              : null
          }
        )

        this.project.getProjectStatusLogs().models.forEach(log => {
          rows.push({
            label: log.getProjectStatus().status,
            value: moment(log.created_at).format('L')
          })
        })
      }

      return rows
    }
  },
  mounted () {
    this.fetchProject()
  },
  methods: {
    fetchProject () {
      const model = new ProjectModel({ id: this.project_id })
      model.fetch().then(() => {
        this.project = model
        this.loading = false
      })
    }
  }
}
</script>
